export default "<p>\n  board-twitter works!\n</p>\n"